import { getVenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import { VenueAnalysisVenueDisplayData } from 'widgets/venueAnalysis/grid/gridData';
import { orderFillsCapsuleStreamedDataSelectors } from './store/streamSlice';
import { useOrderFillsCapsuleConfigSlice } from './store/configslice';
import { useOrderFillsCapsuleStrategy } from './orderFillsCapsuleStrategy';
import orderBy from 'lodash/orderBy';

export interface OrderFillsCapsuleData {
    orderData: VenueAnalysisVenueDisplayData[];
}

export function useOrderFillsCapsuleData(): OrderFillsCapsuleData {
    const { useWidgetStreamData } = orderFillsCapsuleStreamedDataSelectors;
    const streamData = useWidgetStreamData();
    const strategy = useOrderFillsCapsuleStrategy();

    const {
        config: { includePreviousDaysFills },
    } = useOrderFillsCapsuleConfigSlice();

    const data = getVenueAnalysisData(
        streamData,
        undefined,
        includePreviousDaysFills
    )!;

    const orderDisplayData = orderBy(
        strategy.getOrderDisplayData(data),
        ['barWidth'],
        ['desc']
    );

    return { orderData: orderDisplayData };
}
